import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/* ✅ Move Field component OUTSIDE to prevent re-render typing issue */
const Field = ({ name, label, type = 'text', placeholder, form, setForm, errors }) => (
  <div>
    <label className="label-sm text-lux-secondary block mb-2">{label}</label>
    <input
      type={type}
      value={form[name]}
      onChange={(e) => {
        const value = e.target.value;
        setForm(prev => ({ ...prev, [name]: value }));
      }}
      placeholder={placeholder}
      className={`input-lux ${errors[name] ? 'border-red-400' : ''}`}
    />
    {errors[name] && (
      <p className="text-red-500 text-xs font-sans mt-1">{errors[name]}</p>
    )}
  </div>
);

export default function Register() {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const { register } = useAuth();
  const navigate = useNavigate();

  const validate = () => {
    const errs = {};
    if (!form.firstName.trim()) errs.firstName = 'First name required';
    if (!form.lastName.trim()) errs.lastName = 'Last name required';
    if (!form.email.includes('@')) errs.email = 'Valid email required';
    if (form.password.length < 6) errs.password = 'Minimum 6 characters';
    if (form.password !== form.confirmPassword)
      errs.confirmPassword = 'Passwords do not match';
    return errs;
  };

  const handleSubmit = async (e) => {

    e.preventDefault()

    const errs = validate()

    if (Object.keys(errs).length > 0) {
      setErrors(errs)
      return
    }

    setLoading(true)

    try {

      await register({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        password: form.password
      })

      // ⭐ IMPORTANT REDIRECT
      navigate('/verify-otp', {
        state: { email: form.email }
      })

    } catch (err) {

      setErrors({
        submit: err.response?.data?.message || 'Registration failed'
      })

    }

    setLoading(false)

  }

  return (
    <div className="min-h-screen flex">
      {/* Left Side Image */}
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden bg-lux-primary">
        <img
          src="https://pixabay.com/photos/man-fashion-model-pose-portrait-9182458/"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 flex flex-col justify-end p-16">
          <Link to="/" className="absolute top-12 left-12">
            <span className="font-display text-2xl text-white tracking-[0.15em]">
              AURÉNE
            </span>
          </Link>
          <h2 className="font-display text-5xl text-white font-light leading-[1.1] mb-4">
            Join the <br />
            <em className="italic text-lux-gold">Collection.</em>
          </h2>
          <p className="font-body text-white/60 text-lg">
            Become part of an exclusive community of curated style.
          </p>
        </div>
      </div>

      {/* Right Side Form */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-8 py-12 bg-lux-bg">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden block mb-8">
            <span className="font-display text-2xl text-lux-primary tracking-[0.15em]">
              AURÉNE
            </span>
          </Link>

          <p className="label-sm text-lux-gold mb-2">Create Account</p>
          <h1 className="font-display text-4xl text-lux-primary mb-2">
            Register
          </h1>

          <p className="font-sans text-sm text-lux-secondary mb-8">
            Already have an account?{' '}
            <Link
              to="/login"
              className="text-lux-primary hover:text-lux-gold transition-colors underline underline-offset-2"
            >
              Sign in
            </Link>
          </p>

          {errors.submit && (
            <div className="bg-red-50 border border-red-200 text-red-600 text-xs font-sans px-4 py-3 mb-6">
              {errors.submit}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <Field
                name="firstName"
                label="First Name"
                placeholder="Jean"
                form={form}
                setForm={setForm}
                errors={errors}
              />
              <Field
                name="lastName"
                label="Last Name"
                placeholder="Dupont"
                form={form}
                setForm={setForm}
                errors={errors}
              />
            </div>

            <Field
              name="email"
              label="Email Address"
              type="email"
              placeholder="jean@example.com"
              form={form}
              setForm={setForm}
              errors={errors}
            />

            <Field
              name="password"
              label="Password"
              type="password"
              placeholder="Min. 6 characters"
              form={form}
              setForm={setForm}
              errors={errors}
            />

            <Field
              name="confirmPassword"
              label="Confirm Password"
              type="password"
              placeholder="Repeat password"
              form={form}
              setForm={setForm}
              errors={errors}
            />

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full text-center disabled:opacity-60"
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}